<mat-expansion-panel
  class="mat-elevation-z0 border border-solid border-zinc-300"
>
  <mat-expansion-panel-header>
    <mat-panel-title class="space-x-4">
      <mat-icon class="icon-sm opacity-70">calendar_month</mat-icon>
      <span class="text-sm font-bold opacity-90">
        Live Automation Timing Examples
      </span>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <table class="w-full border-separate border-spacing-y-1 text-sm">
    <thead>
      <tr class="text-left opacity-80">
        <th>Appointment Date</th>
        <th>Automation Will Go Out On</th>
      </tr>
    </thead>
    <tbody class="leading-none">
      @for (example of timingExamples(); track example.appointmentDate) {
        <tr>
          <td>
            {{ example.appointmentDate }}
          </td>
          <td>
            {{ example.automationDate }}
            @if (example.automationTime) {
              at {{ example.automationTime }}
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</mat-expansion-panel>
